import { React } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from './LandingPages/LandingPage';
import UserScheduleAppointmentsPage from "./UserPages/UserScheduleAppointmentsPage";
import UsersManagementPage from "./ClinicPages/UsersManagementPage";
import ProtectedRoutes from './ProtectedRoutes';
import { UserRoles } from "./auth.ts";
import { Segment } from "semantic-ui-react";
import HomePage from "./LandingPages/HomePage.jsx";
import { SemanticToastContainer } from 'react-semantic-toasts';
import { AppContextProvider } from "./AppContext.jsx";
import { ResponsiveContainer } from "./LandingPages/NavBars.jsx";
import Signout from "./LandingPages/Signout.jsx"
import ResetPasswordPage from "./LandingPages/ResetPasswordPage.jsx";
import ConfigEditPage from "./ClinicPages/ConfigEditPage.jsx";
import ClinicAppointmentsPage from "./ClinicPages/ClinicAppointmentsPage.jsx";

const App = () => {
  const rtlLanguages = ["he"]

  function setPageDirection(language) {
    const dir = rtlLanguages.includes(language) ? "rtl" : "ltr"
    document.documentElement.dir = dir
  }

  setPageDirection(localStorage.getItem("lang") || 'he')
 

  return (
    <>
      <SemanticToastContainer className="toast-container" position="top-right" />
      <BrowserRouter>
        <AppContextProvider>
          <ResponsiveContainer>
              <Segment className="page-segment" basic raised color="blue">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/signin" element={<LandingPage />} />
                  <Route path="/signout" element={<Signout />} />
                  <Route path="/reset_password" element={<ResetPasswordPage />} />
                  <Route element={<ProtectedRoutes kind={UserRoles.AUTHORIZED_COMMANDER} />}>
                    <Route path="/schedule" element={<UserScheduleAppointmentsPage />} />
                  </Route>
                  <Route path="/clinic" element={<ProtectedRoutes kind={UserRoles.AUTHORIZED_DOCTOR} />}>
                    <Route path="schedule" element={<ClinicAppointmentsPage />} />
                    <Route path="users" element={<UsersManagementPage />} />
                    <Route path="config" element={<ConfigEditPage />} />
                  </Route>
                  <Route path="/404" element={<div>ארמקום לא נמצא</div>} />
                  <Route path="*" element={<Navigate replace to="/404" />} />
                </Routes>
              </Segment>
          </ResponsiveContainer>
        </AppContextProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
